import { Facebook, Instagram, MapPin, MessageCircle } from 'lucide-react';

const ContactInfo = () => {
  return (
    <div className="flex flex-col space-y-4 text-gray-300">
      {/* Adresse */}
      <div className="flex items-start space-x-4">
        <MapPin className="w-6 h-6 text-customAqua100" />
        <div>
          <p className="font-medium">Adresse</p>
          <p className="text-gray-400">
            Rue Aguelmane Sidi Ali, Imm.18,
            <br />
            1er étage, Appt 4, AGDAL
          </p>
        </div>
      </div>

      {/* Réseaux sociaux */}
      <div className="flex space-x-4 mt-2">
        {/* Facebook */}
        <a
          href="https://www.facebook.com/profile.php?id=61571051720052"
          target="_blank"
          rel="noopener noreferrer"
          className="text-customAqua100 hover:text-blue-600 transition-transform duration-300 hover:scale-110"
        >
          <Facebook className="w-6 h-6" />
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/dr.cherkaouiabir/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-customAqua100 hover:text-pink-500 transition-transform duration-300 hover:scale-110"
        >
          <Instagram className="w-6 h-6" />
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/212663391500"  // Remplace par ton numéro
          target="_blank"
          rel="noopener noreferrer"
          className="text-customAqua100 hover:text-green-500 transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle className="w-6 h-6" />
        </a>
      </div>
    </div>
  );
};

export default ContactInfo;
